import { api } from "@shared/api/client";
import type { ExplorerSystem, PidDetail } from "../types";

export async function getPlantTree(plantId: string): Promise<ExplorerSystem[]> {
  const { data } = await api.get<ExplorerSystem[]>(
    `/pid-explorer/plants/${plantId}/tree`,
  );
  return data;
}

export async function getPidDetail(
  plantId: string,
  pidId: string,
): Promise<PidDetail> {
  const { data } = await api.get<PidDetail>(
    `/pid-explorer/plants/${plantId}/pids/${pidId}`,
  );
  return data;
}

/** react-pdf streams the drawing itself, so it needs the absolute URL. */
export function getPidPdfUrl(plantId: string, pidId: string): string {
  return `${import.meta.env.VITE_BE_BASE_URL}pid-kks-extractor/pid-explorer/plants/${plantId}/pids/${pidId}/pdf`;
}
